import { getStorage, removeStorage, storageKey } from '@/utils/storage'

export default {
	getSecrecy({ commit }) {
		let secrecy = getStorage(storageKey.secrecy);
		return new Promise((reslove, reject) => {
			if (secrecy === null) {
				reject();
			}else {
				let secrecyObj = JSON.parse(secrecy);
				let timeStamp = new Date().getTime();
				if (timeStamp > secrecyObj.expires) {//过期
					commit('SET_SECRECY', null);
					reject();
				}else {
					commit('SET_SECRECY', secrecyObj);
					reslove();
				}
			}


		})
	},
	initUser({ commit }) {
		let user = JSON.parse(getStorage(storageKey.user));
		if (user === null) {
			let info = {
				storeName: '',//店铺名称 不超过255位
				usedPos: '',//是否使用过收银系统
				industry: '',//所属行业
				storeNum: '',//门店数量
				investmentAmount: '',//门店平均投资
			}
			commit('SET_USER', info);
		} else {
			commit('SET_USER', user);
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/actions.js